import * as v from 'valibot';
import { scheduleTimeSchema } from '../types/ScheduleTime';
export const scheduleOperationSchema = v.union([
    v.literal('on'),
    v.literal('off'),
    v.literal('dim'),
    v.literal('zigbee on'),
    v.literal('zigbee off'),
]);
export const scheduleSchema = v.object({
    id: v.number(),
    active: v.boolean(),
    device_id: v.number(),
    dim_level: v.number(),
    next_run: v.string(),
    operation: scheduleOperationSchema,
    transmitter_id: v.number(),
    time: scheduleTimeSchema
});
